<template>
  <b-modal ref="modal-bookmark"      
      modal-header="false"
      @mousedown.self="closeModal"
      @close="closeModal"
      @hide="closeModal"
      :hide-header="true"
      :hide-footer="true"
      size="sm"
      centered
      content-class="modal-bookmark"
      ok-only>
      <div class="bookmark-content" :style="{ '--main-color': $root.mainColor }">
        <button class="bookmark-close" @click="closeModal">
          <i class="fa fa-times"></i>
        </button>
        <h1 class="bookmark-logo">
          <i class="fa fa-bookmark"></i>
        </h1>
        <p class="bookmark-text">
          {{translation('bookmark_website_caps', 'Bookmark our website for future orders ;)')}}
        </p>
        <button class="btn bookmark-confirm" @click="closeModal">{{translation('sure_caps', 'Sure')}}</button>
      </div>      
  </b-modal>  
</template>
<style lang="scss">
  .modal-content {
    &.modal-bookmark {
      max-width: 300px;
      margin: 0 auto;
      border-radius: 12px;
      .bookmark-content {
        margin-top: 20px;
        .bookmark-close {
          position: absolute;
          right: 16px;
          top: 16px;
          background: #F3F3F3;
          border-radius: 100%;
          border: none;
          color: #727272;
        }
        .bookmark-logo {
          text-align: center;
          font-size: 140px;
          color: #F22424;
        }
        .bookmark-text {
          font-family: Work Sans;
          font-style: normal;
          font-weight: 500;
          font-size: 18px;
          line-height: 22px;
          display: flex;
          align-items: center;
          text-align: center;
          color: #1E1E1E;
        }
        .bookmark-confirm {
          margin-top: 20px;
          height: 51.67px;          
          background: var(--main-color);
          border-radius: 8px;
          width: 100%;
          color: #fff;
        }
      }
    }    
  }  
</style>
<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { TranslationMixin, HelperMixin } from '@/mixins'

export default {
  name: 'BookmarkModal',
  props: {
    show: Boolean,
  },
  mixins: [TranslationMixin],
  data() {
    return {
    }
  },  
  computed: {
    ...mapGetters({
      getLocale: 'app/getLocale'
    })
  },
  watch: {
    show(val) {
      if(val) {
        this.$refs['modal-bookmark'].show();
      } else {
        this.$refs['modal-bookmark'].hide();
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    }    
  }
}
</script>